export const trackCTA = (label: string, location: string) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "cta_click", {
      event_category: "CTA",
      event_label: label,
      event_location: location,
    });
  }
};

export const trackScrollDepth = (depth: string, pagePath: string) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "scroll_depth", {
      event_category: "Engagement",
      depth,
      page_path: pagePath,
    });
  }
};
